<div fxLayout="column" class="cms-table-container" style="height: calc(100vh - 130px)">
  <!-- Filter -->
  <div *ngIf="isFilterable" fxLayout="row" fxLayoutAlign="space-between" fxLayout.lt-md="column">
   <ng-container *ngIf='isFilterable'>
     <form #from="ngForm" (ngSubmit)="emitFilter(from.value.query)">
       <mat-form-field>
         <mat-label>Filter</mat-label>
         <input matInput name="query" ngModel placeholder="filter" />
         <button mat-icon-button matSuffix color="primary">
           <mat-icon>search</mat-icon>
         </button>
       </mat-form-field>
       <button *ngIf='filters.length > 0' mat-icon-button matSuffix color="primary" (click)='panelOpenState = !panelOpenState;' type='button'>
          <mat-icon fontSet='material-icons-outlined'>filter_alt</mat-icon>
       </button>
     </form>
   </ng-container>
    <ng-container *ngIf="isExportExcel">
      <div>
        <button mat-raised-button (click)="exportAction()" id="export-excel">
          Export As Excel
        </button>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf='filters.length > 0 && panelOpenState'>
    <filters [filters]='filters'
              (queryParamFilter)='emitQueryParamFilter($event)'></filters>
  </ng-container>
  <!-- Table Container -->
  <div class="base-table-container">
    <!-- Table -->
    <table class="base-table" fxFlex mat-table [dataSource]="tableDataSource" matSort
      (matSortChange)="sortTable($event)">
      <ng-container *ngFor="let tableColumn of tableColumns" [matColumnDef]="tableColumn.name">
        <!-- if sortable column header -->
        <ng-container *ngIf="tableColumn.isSortable; else notSortable">
          <th mat-header-cell *matHeaderCellDef [mat-sort-header]="tableColumn.name" [ngClass.lt-md]="'table-cell'"
            [arrowPosition]="
            tableColumn.position === 'right' ? 'before' : 'after'
          ">
            <span style="text-transform: capitalize;">{{ tableColumn.name }}</span>
          </th>
        </ng-container>
        <!-- else not sortable -->
        <ng-template #notSortable>
          <th mat-header-cell *matHeaderCellDef [class.text-right]="tableColumn.position == 'right'"
            [ngClass.xs]="'table-cell'">
            <span style="text-transform: capitalize;">{{ tableColumn.name }}</span>
          </th>
        </ng-template>

        <!-- column data -->
        <td mat-cell *matCellDef="let element" [class.text-right]="tableColumn.position == 'right'"
          [ngClass.xs]="'table-cell'">
          <ng-container *ngIf="tableColumn.dataKey == 'actions'">
            <ng-container *ngIf="element[tableColumn.dataKey].length < 3">
              <ng-container *ngFor="let action of element[tableColumn.dataKey]">
                <button mat-button (click)="emitRowAction({element: element, action: action})">
                  <mat-icon matTooltip="{{action.name}}">{{ action.icon }}</mat-icon>
                </button>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="element[tableColumn.dataKey].length  >= 3">
              <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <ng-container *ngFor="let action of element[tableColumn.dataKey]">
                  <button mat-menu-item (click)="emitRowAction({element : element , action: action})">
                    <mat-icon>{{action.icon}}</mat-icon>
                    <span>{{action.name}}</span>
                  </button>
                </ng-container>
              </mat-menu>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="tableColumn.dataKey != 'actions'">
            <ng-container *ngIf="tableColumn.isBoolean">
              <mat-icon> {{
                element[tableColumn.dataKey] | PropertyKey:
                tableColumn.propertyKey:tableColumn.isBoolean:tableColumn.booleanOption
                }}
              </mat-icon>
            </ng-container>

            <ng-container *ngIf="!tableColumn.isBoolean">
              <div [ngStyle]="tableColumn.clickable ? {'cursor': 'pointer'}: {'pointer-events': 'none'}"
              ngClass="{{tableColumn.isCssClass ? element.cssClass : ''}}"
                (click)="emitCellAction(tableColumn.dataKey, element)" class="data-in-cell">
                {{
                element[tableColumn.dataKey] | PropertyKey:
                tableColumn.propertyKey:tableColumn.isBoolean:tableColumn.booleanOption
                }}
              </div>
            </ng-container>

          </ng-container>

        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <!-- Pagination -->
  <mat-paginator *ngIf="isPageable" [pageSizeOptions]="paginationSizes" [pageSize]="defaultPageSize"
    showFirstLastButtons [length]="totalRows" [pageIndex]="currentPage" (page)="emitPageChanged($event)">
  </mat-paginator>
</div>
